<template>
  <!-- // tw-px-10 tw-py-8 -->
  <div class="tw-flex tw-flex-col tw-gap-4 tw-w-96">
    <div
      v-if="resourceLimitModalType === 'resoucesRestored'"
      class="tw-text-base tw-text-slate-600 tw-mt-4"
      v-html="$t('pricingPlans.resourcesRestored.message')"
    />

    <div
      v-else-if="!isResourceUseLimitReached"
      class="tw-text-sm tw-text-slate-600"
      v-html="$t('pricingPlans.resourceLimitNotReached.message')"
    />

    <div
      v-else
      class="tw-text-sm tw-text-slate-600"
      v-html="$t('pricingPlans.resourceLimitReached.message')"
    />

    <PlansOptions v-for="plan in plans" :key="plan.id" :plan="plan" />
  </div>
</template>

<script setup>
import { useUserMetricsStore } from '@/stores/userMetrics'
import { usePlanCards } from '@/composables/usePlanCards'

const userMetricsStore = useUserMetricsStore()
const { isResourceUseLimitReached, resourceLimitModalType } =
  storeToRefs(userMetricsStore)

const { plans } = usePlanCards()
</script>

<style lang="scss" scoped></style>
